import { render, staticRenderFns } from "./SolicitacaoRespostaListagem.vue?vue&type=template&id=ff9afe1a"
import script from "./SolicitacaoRespostaListagem.vue?vue&type=script&lang=js"
export * from "./SolicitacaoRespostaListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports